import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";

import { tabsName } from "../const";
import { InvoiceTemplateContext } from "../InvoiceTemplateContext";

const SelectableSection = ({
  as: Tag = "div",
  section,
  isSelectable,
  ...props
}) => {
  const [selectable, setSelectable] = useState(isSelectable);
  const { dispatch, state } = useContext(InvoiceTemplateContext);
  const [selected, setSelected] = useState(() => {
    return state.selectedSection === section;
  });

  const handleClick = event => {
    if (selectable) {
      dispatch({
        type: "selectSection",
        payload: { section, selected: !selected },
      });
      setSelected(!selected);
    }
  };

  useEffect(() => {
    setSelected(state.selectedSection === section);
  }, [state.selectedSection, section]);

  useEffect(() => {
    setSelectable(isSelectable && state.activeTab === tabsName.detail);
  }, [state.activeTab, isSelectable]);

  return (
    <Tag
      // @ts-ignore
      onClick={handleClick}
      className={`${selectable && "selectable-section"} ${
        selected && "selected"
      }`}
      {...props}
    />
  );
};

SelectableSection.propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node,
  section: PropTypes.string,
  isSelectable: PropTypes.bool,
};

export default SelectableSection;
